import { createContext as e, useContext as o } from "react";
const t = e(!1), x = t.Provider, n = () => o(t);
export {
  x as TextProvider,
  n as useTextContext
};
